module.exports = __webpack_public_path__ + "static/media/pagination-back-previous.6e5d6c84.svg";